import { useEffect } from 'react';
import { parse, isValid } from 'date-fns';

/**
 * Parse ``?date=YYYY-MM-DD`` from a URLSearchParams-like source.
 *
 * @param {URLSearchParams} searchParams
 * @returns {Date | null}
 */
export function parseModelPageDateFromSearchParams(searchParams) {
  const raw = searchParams.get('date');
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null;
  const parsed = parse(trimmed, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
}

/**
 * ``useState`` initializer so the first predictions request uses ``?date=`` (avoids one wrong-day fetch).
 *
 * @returns {Date}
 */
export function getInitialDateForModelPage() {
  if (typeof window === 'undefined') return new Date();
  try {
    const parsed = parseModelPageDateFromSearchParams(new URLSearchParams(window.location.search));
    return parsed ?? new Date();
  } catch {
    return new Date();
  }
}

/**
 * When the URL contains ``?date=YYYY-MM-DD``, align the model page date picker (e.g. links from Game Picks).
 *
 * @param {URLSearchParams} searchParams
 * @param {React.Dispatch<React.SetStateAction<Date>>} setSelectedDate
 */
export function useDateQueryParam(searchParams, setSelectedDate) {
  useEffect(() => {
    const parsed = parseModelPageDateFromSearchParams(searchParams);
    if (parsed) setSelectedDate(parsed);
  }, [searchParams, setSelectedDate]);
}
